import { render, staticRenderFns } from "./ProductCategoryField.vue?vue&type=template&id=539648f8"
import script from "./ProductCategoryField.vue?vue&type=script&lang=js"
export * from "./ProductCategoryField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports